import { Navigate, Outlet, useSearchParams } from "react-router";

import { useAuthStore } from "@/client/stores/auth";

export const GuestGuard = () => {
  const isLoggedIn = useAuthStore((state) => !!state.user);

  const [searchParams] = useSearchParams();
  const resumeId = searchParams.get("resumeId");
  const previewId = searchParams.get("previewId");
  const redirect = resumeId
    ? `/builder/${resumeId}`
    : previewId
      ? `/preview/${previewId}`
      : searchParams.get("redirect") ?? "/dashboard";

  if (isLoggedIn) {
    return <Navigate replace to={redirect} />;
  }

  return <Outlet />;
};
